import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyGeneralInformationComponent } from './company-general-information/company-general-information.component';
import { InitialInfoComponent } from './initial-info/initial-info.component';
import { SaftyEnvironmentManagementComponent } from './safty-environment-management/safty-environment-management.component';
import { RelevantConstructionExpereinceComponent } from './relevant-construction-expereince/relevant-construction-expereince.component';
import { DeclarationComponent } from './declaration/declaration.component';
import { FinancialInformationComponent } from './financial-information/financial-information.component';
import { LegalComplianceComponent } from './legal-compliance/legal-compliance.component';
import { QmsComponent } from './qms/qms.component';
import { ReferencesComponent } from './references/references.component';
import { SustainbilityComponent } from './sustainbility/sustainbility.component';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { DialogFooterComponent } from '@/app/components/global/dialog-footer/dialog-footer.component';
import { ReloadPqqApplicantDataService } from '@/app/services/shared/reload-pqq-applicant-data.service';
@Component({
  standalone: true,
  imports: [
    CommonModule,
    CompanyGeneralInformationComponent,
    InitialInfoComponent,
    SaftyEnvironmentManagementComponent,
    RelevantConstructionExpereinceComponent,
    DeclarationComponent,
    FinancialInformationComponent,
    LegalComplianceComponent,
    QmsComponent,
    ReferencesComponent,
    SustainbilityComponent,
    DialogFooterComponent,
  ],
  selector: 'app-applicant-pqq-sections',
  templateUrl: './applicant-pqq-sections.component.html',
  styleUrls: ['./applicant-pqq-sections.component.css'],
})
export class ApplicantPqqSectionsComponent implements OnInit {
  currentStep = 1;
  applicantData: any;

  @Output() closeModalEvent = new EventEmitter<boolean>();
  @Input() pqqReferenceDates: any;
  @Input() isEdit: boolean;

  @ViewChild(InitialInfoComponent) initialInfo!: InitialInfoComponent;
  @ViewChild(CompanyGeneralInformationComponent)
  compnayInfo!: CompanyGeneralInformationComponent;
  @ViewChild(SaftyEnvironmentManagementComponent)
  environmentSafety!: SaftyEnvironmentManagementComponent;
  @ViewChild(RelevantConstructionExpereinceComponent)
  constructionExp!: RelevantConstructionExpereinceComponent;
  @ViewChild(QmsComponent) qmsInfo!: QmsComponent;
  @ViewChild(FinancialInformationComponent)
  financeInfo!: FinancialInformationComponent;
  @ViewChild(LegalComplianceComponent) legalInfo!: LegalComplianceComponent;
  @ViewChild(SustainbilityComponent)
  sustainabilityInfo!: SustainbilityComponent;
  @ViewChild(ReferencesComponent) referenceInfo!: ReferencesComponent;
  @ViewChild(DeclarationComponent) declarationInfo!: DeclarationComponent;
  isFetchApplicantData: boolean = false;
  constructor(
    private projectsService: ProjectsService,
    private reloadPqqApplicantDataService: ReloadPqqApplicantDataService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getSubmittedResponseData();
    this.reloadPqqApplicantDataService.reloadPqqApplicantData$.subscribe(() => {
      this.getSubmittedResponseData();
    });
  }

  nextStep() {
    if (this.currentStep < 10) {
      this.currentStep++;
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  getSubmittedResponseData() {
    this.projectsService.PQQSubmittedResponseData().subscribe({
      next: (response) => {
        this.applicantData = response?.data;
        this.isFetchApplicantData = !this.isFetchApplicantData;
        this.cdr.detectChanges();
      },
      error: (error) => console.error('Error fetching response:', error),
    });
  }

  handleCloseModal(closeModalValue: boolean) {
    if (closeModalValue) {
      this.closeModalEvent.emit(closeModalValue);
    }
  }

  onFooterNext() {
    this.executeStepAction('onSubmit');
  }

  onFooterBack() {
    this.executeStepAction('handleBack');
    this.reloadPqqApplicantDataService.reloadPqqApplicantData();
  }

  private executeStepAction(action: 'onSubmit' | 'handleBack') {
    const stepComponents = [
      this.initialInfo,
      this.compnayInfo,
      this.environmentSafety,
      this.constructionExp,
      this.qmsInfo,
      this.financeInfo,
      this.legalInfo,
      this.sustainabilityInfo,
      this.referenceInfo,
      this.declarationInfo,
    ];

    const component = stepComponents[this.currentStep - 1];
    if (component && typeof component[action] === 'function') {
      component[action]();
    }
  }
}
